import { app } from '../../../app';
import { Controller } from './reset-password-verify.controller';

app.component('resetPasswordVerify', {
    bindings:{
        appData:'<',
        rkey:'<',
        appName:'<',
        username:'<'
    },
    controller: Controller,
    templateUrl: require('./reset-password-verify.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password-verify/reset-password-verify.component.js